export const CLEAR = '@messages/CLEAR';
export const MESSAGES_SHOW = '@messages/SHOW';
export const MESSAGES_HIDE = '@messages/HIDE';
